module.exports = __webpack_public_path__ + "static/img/50.55aeddd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/50.jpg
// module id = rx94
// module chunks = 1